import { Component, OnDestroy, OnInit } from '@angular/core';
import { I18nService } from '@app/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';

@Component({
  selector: 'signup-language-switcher',
  templateUrl: './signup-language-switcher.component.html',
  styleUrls: ['./signup-language-switcher.component.scss']
})

export class SignupLanguageSwitcherComponent implements OnInit, OnDestroy {

  config = {
    language: ''
  };

  private onDestroy$ = new Subject<boolean>();

  constructor(private i18nService: I18nService, private store: Store) {
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  ngOnInit() {
    this.config.language = this.currentLanguage;
  }

  setLanguage(language: string) {
    this.i18nService.setLanguage(language);
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

}
